import React from 'react';
import { css } from '@bts-web/utils-style-engine';
import { SVGIconType } from '../types';

const RegularShieldTask: React.FC<SVGIconType> = ({
  color,
  size = 22,
  width,
  height,
  className,
  ...restProps
}) => {
  const wrapperClassName = css({
    color: color || 'neutrals.text_primary',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: width || size,
    height: height || size,
  });

  return (
    <span
      data-testid="icon_shield-task"
      className={
        className ? `${wrapperClassName} ${className}` : wrapperClassName
      }
      data-element="icon"
      aria-label="shield-task icon"
      {...restProps}
    >
      <svg
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        width={`${size}px`}
        height={`${size}px`}
        fill="currentcolor"
      >
        <path d="M10 2C12.2091 2 14 3.79086 14 6V8H15.75C16.9926 8 18 9.00736 18 10.25L18.0004 11C17.6815 11 17.3626 11.1096 17.1038 11.3286L16.9966 11.4293C16.8328 11.5998 16.6678 11.7519 16.5009 11.886L16.5 10.25C16.5 9.83579 16.1642 9.5 15.75 9.5H4.25C3.83579 9.5 3.5 9.83579 3.5 10.25V19.75C3.5 20.1642 3.83579 20.5 4.25 20.5L14.1384 20.5008C14.546 21.0774 15.0606 21.579 15.6783 22.0005L4.25 22C3.00736 22 2 20.9926 2 19.75V10.25C2 9.00736 3.00736 8 4.25 8H6V6C6 3.79086 7.79086 2 10 2ZM18.2837 12.1223C19.2758 13.1576 20.3751 13.6667 21.6 13.6667C21.7933 13.6667 21.9546 13.8095 21.9919 13.9994L22 14.0833V16.5844C22 19.2663 20.687 21.0896 18.1265 21.9786C18.0444 22.0071 17.9556 22.0071 17.8735 21.9786C15.3984 21.1192 14.0889 19.3868 14.0044 16.8497L14 16.5844V14.0833C14 13.8532 14.1791 13.6667 14.4 13.6667C15.6234 13.6667 16.7233 13.1575 17.7178 12.122C17.8741 11.9592 18.1276 11.9594 18.2837 12.1223ZM10.0001 13.5C10.8286 13.5 11.5001 14.1716 11.5001 15C11.5001 15.8284 10.8286 16.5 10.0001 16.5C9.1717 16.5 8.50012 15.8284 8.50012 15C8.50012 14.1716 9.1717 13.5 10.0001 13.5ZM10 3.5C8.61929 3.5 7.5 4.61929 7.5 6V8H12.5V6C12.5 4.61929 11.3807 3.5 10 3.5Z" />
      </svg>
    </span>
  );
};

export { RegularShieldTask };
